<template>
  <v-container class="grey lighten-5">
    <h2>PDFs</h2>
    <br/>
    <v-data-table
        :headers="standardHeaders"
        :items="packages"
        :search="search"
        :items-per-page="15"
        class="elevation-1"
    >
      <template v-slot:top>
        <v-text-field
            append-icon="mdi-magnify"
            v-model="search"
            single-line
            label="Suche"
            class="mx-4"
        />
      </template>

      <template v-slot:item.delete="{ item }">
        <v-btn class="ma-2" color="indigo" x-small fab outlined @click="deletePackage(item)">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>

    </v-data-table>

    <v-file-input
        truncate-length="24"
        accept="application/pdf"
        @change="fileSelected"
        label="PDF Datei auswählen"
    ></v-file-input>
    <v-btn class="ma-1" color="info" :loading="loading"
           :disabled="loading || pdf===null" @click="uploadPackage">
      PDF hochladen
      <template v-slot:loader>
        <span class="custom-loader">
          <v-icon light>mdi-cached</v-icon>
        </span>
      </template>
    </v-btn>
    <v-progress-linear
        class="ma-1"
        v-if="loading"
        v-model="progress"
        height="25"
    >
      <strong>{{ Math.ceil(progress) }}%</strong>
    </v-progress-linear>
    <v-snackbar :timeout="5000" :value="error" color="error" left shaped top app>{{ errorText }}</v-snackbar>
    <v-snackbar :timeout="5000" :value="success" color="primary" left shaped top app>{{ successText }}</v-snackbar>

  </v-container>

</template>

<script>

import CourseRun from "@/components/CourseExecution.vue";
import Course from "@/models/Course";
import {default as CourseRunModel} from "@/models/CourseRun";

export default {
  name: "SuperAdminPdfStorageSettings",
  data: () => ({
    packages: [],
    loading: false,
    pdf: null,
    search: '',
    error: false,
    success: false,
    progress: 0,
    errorText: "",
    successText: "Erfolgreich hochgeladen",
    standardHeaders: [
      {
        text: "Titel",
        value: "title",
      },
      {
        text: "Löschen", value: "delete",
        sortable: false,
      },
    ]
  }),
  methods: {
    uploadPackage() {
      this.loading = true;
      this.$httpPdfStorageApi.upload(this.pdf, (progress) => {
        this.progress = Math.round((100 * progress.loaded) / progress.total);
      }, () => {
        this.loading = false;
        this.successText = "Erfolgreich hochgeladen"
        this.success = true;
        setTimeout(() => {
          this.success = false;
          this.loadData();
        }, 3000);
        this.pdf = null;
      }, () => {
        this.loading = false;
        this.errorText = "Fehler beim Hochladen der Datei."
        this.error = true;
        setTimeout(() => this.error = false, 5000);
      })
    },
    fileSelected(file) {
      this.pdf = file;
    },
    deletePackage(file) {
      this.$httpPdfStorageApi.delete(file.title, () => {
        this.loadData();
        this.successText = "Erfolgreich gelöscht"
        this.success = true;
        setTimeout(() => this.success = false, 3000);
      }, () => {
        this.errorText = "Fehler beim Löschen."
        this.error = true;
        setTimeout(() => this.error = false, 3000);
      })
    },
    loadData() {
      this.$httpPdfStorageApi.getAll((result) => {
        this.packages = result.map((date) => {
          let result = {"title": date}
          return result
        });
      })
    },
  },
  mounted() {
    this.loadData();
  }
}
</script>

<style scoped>

</style>
